// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SecurityScanOutlinedSvg from "@ant-design/icons-svg/es/asn/SecurityScanOutlined";
import AntdIcon from '../components/AntdIcon';

var SecurityScanOutlined = function SecurityScanOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: SecurityScanOutlinedSvg
  }));
};

SecurityScanOutlined.displayName = 'SecurityScanOutlined';
export default React.forwardRef(SecurityScanOutlined);